/** @typedef {{ role?: string, subscribed?: boolean, capabilities?: Record<string, boolean> }} AuthUser */

export const ROLES = {
  SUPER_ADMIN: 'super_admin',
  ADMIN: 'admin',
  MANAGER: 'manager',
  TEAM_MEMBER: 'team_member',
  CLIENT: 'client',
};

export const ROLE_LABELS = {
  [ROLES.SUPER_ADMIN]: 'Super admin',
  [ROLES.ADMIN]: 'Company admin',
  [ROLES.MANAGER]: 'Team admin',
  [ROLES.TEAM_MEMBER]: 'Team member',
  [ROLES.CLIENT]: 'Client',
};

/**
 * @param {AuthUser | null | undefined} user
 */
export function homePathForUser(user) {
  if (!user) {
    return '/';
  }
  switch (user.role) {
    case ROLES.SUPER_ADMIN:
      return '/super-admin';
    case ROLES.ADMIN:
    case ROLES.MANAGER:
    case ROLES.TEAM_MEMBER:
      return user.subscribed || user.capabilities?.subscribed ? '/admin' : '/admin/billing';
    default:
      return '/my/dashboard';
  }
}

/**
 * @param {AuthUser | null | undefined} user
 */
export function isCompanyStaff(user) {
  return (
    user?.role === ROLES.ADMIN || user?.role === ROLES.MANAGER || user?.role === ROLES.TEAM_MEMBER
  );
}

/**
 * @param {AuthUser | null | undefined} user
 * @param {string} capability
 */
export function hasCapability(user, capability) {
  return Boolean(user?.capabilities?.[capability]);
}

/**
 * @param {AuthUser | null | undefined} user
 */
export function isSubscribed(user) {
  return Boolean(user?.subscribed || user?.capabilities?.subscribed);
}
